import React, { useState } from 'react';
import { Plus, Upload, Edit2, Trash2, Eye } from 'lucide-react';
import { Button } from './Button';

export const SalesDetails = () => {
    const [activeTab, setActiveTab] = useState('b2b');
    const [salesInvoices] = useState([
        {
            id: '1',
            invoiceNo: 'INV001',
            date: '2024-01-15',
            partyName: 'ABC Industries Ltd.',
            gstType: 'B2B',
            amount: 25000,
            tax: 4500,
            status: 'Filed'
        },
        {
            id: '2',
            invoiceNo: 'INV002',
            date: '2024-01-16',
            partyName: 'XYZ Corporation',
            gstType: 'B2B',
            amount: 15000,
            tax: 2700,
            status: 'Pending'
        }
    ]);

    const tabs = [
        { id: 'b2b', label: 'B2B Sales', count: 12 },
        { id: 'b2c', label: 'B2C Sales', count: 8 },
        { id: 'exports', label: 'Exports', count: 3 },
        { id: 'credit-notes', label: 'Credit Notes', count: 2 },
        { id: 'advances', label: 'Advances', count: 5 },
        { id: 'e-invoice', label: 'E-Invoice', count: 10 }
    ];

    const totalSales = salesInvoices.reduce((sum, invoice) => sum + invoice.amount, 0);
    const totalTax = salesInvoices.reduce((sum, invoice) => sum + invoice.tax, 0);


    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold text-gray-900">Sales Details (Outward Supply)</h2>
                <div className="flex space-x-2">

                    <Button label="Import Excel" />
                    <Button label="Add Invoice" />
                </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200 mb-6">
                <nav className="-mb-px flex space-x-8">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`py-2 px-1 border-b-2 font-medium text-sm ${activeTab === tab.id
                                ? 'border-blue-500 text-blue-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            {tab.label}
                            <span className="ml-2 bg-gray-100 text-gray-900 py-0.5 px-2 rounded-full text-xs">
                                {tab.count}
                            </span>
                        </button>
                    ))}
                </nav>
            </div>

            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="bg-blue-50 rounded-lg p-4">
                    <h3 className="text-sm font-medium text-blue-900">Total Sales Value</h3>
                    <p className="text-2xl font-bold text-blue-600">₹{totalSales.toLocaleString()}</p>
                </div>
                <div className="bg-green-50 rounded-lg p-4">
                    <h3 className="text-sm font-medium text-green-900">Total Tax</h3>
                    <p className="text-2xl font-bold text-green-600">₹{totalTax.toLocaleString()}</p>
                </div>
                <div className="bg-purple-50 rounded-lg p-4">
                    <h3 className="text-sm font-medium text-purple-900">Net Amount</h3>
                    <p className="text-2xl font-bold text-purple-600">₹{(totalSales + totalTax).toLocaleString()}</p>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Invoice Details
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Party Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Amount
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Tax
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {salesInvoices.map((invoice) => (
                            <tr key={invoice.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div>
                                        <div className="text-sm font-medium text-gray-900">{invoice.invoiceNo}</div>
                                        <div className="text-sm text-gray-500">{invoice.date}</div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">{invoice.partyName}</div>
                                    <div className="text-sm text-gray-500">{invoice.gstType}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    ₹{invoice.amount.toLocaleString()}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    ₹{invoice.tax.toLocaleString()}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${invoice.status === 'Filed'
                                        ? 'bg-green-100 text-green-800'
                                        : 'bg-yellow-100 text-yellow-800'
                                        }`}>
                                        {invoice.status}
                                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                    <div className="flex space-x-2">
                                        <button className="text-blue-600 hover:text-blue-900">
                                            <Eye className="h-4 w-4" />
                                        </button>
                                        <button className="text-gray-600 hover:text-gray-900">
                                            <Edit2 className="h-4 w-4" />
                                        </button>
                                        <button className="text-red-600 hover:text-red-900">
                                            <Trash2 className="h-4 w-4" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};